import insuranceData from "./insuranceData.json";

// Add/remove insurances or states in insuranceData.json.
// Every insurance/state pair automatically becomes a page.
// URL format: /{insurance-slug}-psychiatrists-in-{state-slug}
// Example: /aetna-psychiatrists-in-florida

const slugify = (s) =>
    s
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");

const buildSlug = ({ insurance, state }) =>
    `${slugify(insurance)}-psychiatrists-in-${slugify(state)}`;

const rawInsurances = insuranceData.states.flatMap((location) =>
    insuranceData.insurances.map((insurance) => ({
        insurance,
        ...location,
    })),
);

const insurances = rawInsurances.map((entry) => ({
    ...entry,
    slug: buildSlug(entry),
}));

export default insurances;
